<div class="container">
  @if (showChartName) {
    <div class="piechartTitle">{{chartName}}</div>
  }
  @if (piechartData.length > 0) {
    <div class="piechart">
      <div class="" [style.width.px]="diameter" [style.height.px]="diameter">
        @if (showPieChart) {
          <google-chart [type]="'PieChart'" [data]="piechartData" [columns]="names" [options]="pieChartOptions" [width]="diameter" [height]="diameter"></google-chart>
        }
      </div>
      <perfect-scrollbar class="scrollbar" [style.height.px]="+diameter">
        @if (showLegend) {
          <div class="piechartLegend" [style.visibility]="showPieChart ? 'visible': 'hidden' ">
            @for (item of piechartData; track item; let i = $index) {
              <div class="legend">
                <div class="color" [style.backgroundColor]="pieChartOptions.slices[i].color"></div>
                <div class="variableName" #variableName insTooltip [cfg]="getToolTipConf(variableName, item[0])">{{item[0]}}</div>
              </div>
            }
          </div>
        }
      </perfect-scrollbar>
    </div>
  }
</div>